import { render } from "./FormularioValor.vue?vue&type=template&id=15f19f4f&scoped=true"
import script from "./FormularioValor.vue?vue&type=script&lang=js"
export * from "./FormularioValor.vue?vue&type=script&lang=js"

import "./FormularioValor.vue?vue&type=style&index=0&id=15f19f4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f19f4f"]])

export default __exports__